'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.metadata = exports.getImageUrl = undefined;

var _hubspot = require('hubspot.bender');

var _metadata = require('./metadata');

var getImageUrl = exports.getImageUrl = function getImageUrl(name) {
  var extension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.svg';
  return _hubspot.staticDomainPrefix + '/ui-images/static-2.105/optimized/' + name + extension;
};

var metadata = exports.metadata = _metadata.metadata;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-images/static-2.105/js/index.js
// module id = 276
// module chunks = 0